<template>
  <div class="h-full p-8">
    <div class="flex gap-4 relative z-[1]">
      <div class="w-8 h-8 ripple" @click="$router.back()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          viewBox="0 0 24 24"
          class="fill-primary w-full h-full"
        >
          <path
            d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"
          ></path>
        </svg>
      </div>
      <div class="text-xl title-color">Permission pour Notifications</div>
    </div>
    <div class="h-[45vh] relative z-[0]">
      <div
        class="absolute bg-[#2A77BB] aspect-square w-full rounded-[50px] rotate-[45deg] left-[30%] -top-[20px]"
      ></div>
    </div>
    <div class="text-2xl font-bold">Notifications</div>
    <div class="py-2"></div>
    <div class="description-color">
      Nous utilisons les notifications pour vous tenir au courant de l'état de
      vos transactions et de l'évolution de King Recharge
    </div>
    <div class="py-2"></div>
    <div>
      <button
        class="buttonComponent flex items-center gap-3"
        @click="activateNotification"
      >
        <div class="w-7 h-7">
          <img
            src="~@/assets/images/all/check-white.svg"
            class="w-full h-full"
            alt=""
          />
        </div>
        <div>Permettre les Notifications</div>
      </button>
    </div>
  </div>
</template>

<script>
import AppDataProperty from '../components/appData/AppDataProperty.vue'
import TransactionList from '../components/transaction/TransactionList.vue'
import UserProperty from '../components/user/UserProperty.vue'

export default {
  components: {
    UserProperty,
    AppDataProperty,
    TransactionList,
  },
  data() {
    return {
      eventsIds: [],
    }
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  mounted() {
    const canAcceptNotification =
      this.$NotificationUtils.canAcceptNotification()
    const notificationIsAccepted =
      this.$NotificationUtils.notificationPermissionIsAccepted()
    if (notificationIsAccepted || !canAcceptNotification) {
      this.$router.push('/home')
      return
    }

    const id1 = this.$Events.handleEvent(
      'notification_permission_accepted',
      this.onPermissionAccepted,
    )
    const id2 = this.$Events.handleEvent(
      'notification_permission_denied',
      this.onPermissionDenied,
    )
    this.eventsIds.push(id1)
    this.eventsIds.push(id2)
  },
  methods: {
    activateNotification() {
      this.$Events.dispatchEvent('request_notification_permission')
    },
    onPermissionAccepted() {
      this.$router.push('/home')
    },
    onPermissionDenied() {
      console.log('permission denied')
    },
  },
}
</script>
